import fronts from '@/apis/coreIAM/fronts'
import { frontsTypes } from '@/store/mutationTypes'

export default {
    state: {
        all: null,
        fetchAll: {
            pending: false,
            error: null,
        },
        fetchOne: {
            pending: false,
            error: null,
        },
        createOne: {
            pending: false,
            error: null,
        },
        updateOne: {
            pending: false,
            error: null,
        },
        deleteOne: {
            pending: false,
            error: null,
        },
    },
    mutations: {
        [frontsTypes.FETCH_ALL_REQUEST]: function (state) {
            state.fetchAll.pending = true;
        },
        [frontsTypes.FETCH_ALL_SUCCESS]: function (state, fronts) {
            state.all = fronts;
            state.all.error = null;
            state.fetchAll.pending = false;
        },
        [frontsTypes.FETCH_ALL_FAILURE]: function (state, error) {
            state.all = null;
            state.fetchAll.error = error;
            state.fetchAll.pending = false;
        },
        [frontsTypes.FETCH_ONE_REQUEST]: function (state) {
            state.fetchOne.pending = true;
        },
        [frontsTypes.FETCH_ONE_SUCCESS]: function (state) {
            state.fetchOne.error = null;
            state.fetchOne.pending = false;
        },
        [frontsTypes.FETCH_ONE_FAILURE]: function (state, error) {
            state.fetchOne.error = error;
            state.fetchOne.pending = false;
        },
        [frontsTypes.CREATE_ONE_REQUEST]: function (state) {
            state.createOne.pending = true;
        },
        [frontsTypes.CREATE_ONE_SUCCESS]: function (state) {
            state.createOne.error = null;
            state.createOne.pending = false;
        },
        [frontsTypes.CREATE_ONE_FAILURE]: function (state, error) {
            state.createOne.error = error;
            state.createOne.pending = false;
        },
        [frontsTypes.UPDATE_ONE_REQUEST]: function (state) {
            state.updateOne.pending = true;
        },
        [frontsTypes.UPDATE_ONE_SUCCESS]: function (state) {
            state.updateOne.error = null;
            state.updateOne.pending = false;
        },
        [frontsTypes.UPDATE_ONE_FAILURE]: function (state, error) {
            state.updateOne.error = error;
            state.updateOne.pending = false;
        },
        [frontsTypes.DELETE_ONE_REQUEST]: function (state) {
            state.deleteOne.pending = true;
        },
        [frontsTypes.DELETE_ONE_SUCCESS]: function (state) {
            state.deleteOne.error = null;
            state.deleteOne.pending = false;
        },
        [frontsTypes.DELETE_ONE_FAILURE]: function (state, error) {
            state.deleteOne.error = error;
            state.deleteOne.pending = false;
        },
    },
    actions: {
        async fetchAll({ commit }) {
            commit(frontsTypes.FETCH_ALL_REQUEST)
            return new Promise((resolve, reject) => {
                fronts
                    .fetchAll()
                    .then((frontsList) => {
                        commit(frontsTypes.FETCH_ALL_SUCCESS, frontsList.data)
                        resolve(frontsList.data)
                    })
                    .catch((error) => {
                        commit(frontsTypes.FETCH_ALL_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async fetchOne({ commit }, payload) {
            commit(frontsTypes.FETCH_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                fronts
                    .fetchOne(payload.uuid)
                    .then((front) => {
                        commit(frontsTypes.FETCH_ONE_SUCCESS)
                        resolve(front.data)
                    })
                    .catch((error) => {
                        commit(frontsTypes.FETCH_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async createOne({ commit }, payload) {
            commit(frontsTypes.CREATE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                fronts
                    .createFront(
                        payload.id,
                        payload.name,
                        payload.description,
                        payload.url,
                        payload.redirectUris,
                        payload.webOrigins,
                    )
                    .then((front) => {
                        commit(frontsTypes.CREATE_ONE_SUCCESS)
                        resolve(front.data)
                    })
                    .catch((error) => {
                        commit(frontsTypes.CREATE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async updateOne({ commit }, payload) {
            commit(frontsTypes.UPDATE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                fronts
                    .updateFront(
                        payload.uuid,
                        payload.id,
                        payload.name,
                        payload.description,
                        payload.url,
                        payload.redirectUris,
                        payload.webOrigins,
                    )
                    .then((front) => {
                        commit(frontsTypes.UPDATE_ONE_SUCCESS)
                        resolve(front.data)
                    })
                    .catch((error) => {
                        commit(frontsTypes.UPDATE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async deleteOne({ commit }, payload) {
            commit(frontsTypes.DELETE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                fronts
                    .deleteFront(payload.uuid)
                    .then(() => {
                        commit(frontsTypes.DELETE_ONE_SUCCESS)
                        resolve()
                    })
                    .catch((error) => {
                        commit(frontsTypes.DELETE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
    }
}